import api from './api';

export const braintreeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getClientToken: builder.query({
      query: ({ restaurantId, isDelivery }) => `braintree/getClientToken/${restaurantId}/${isDelivery}`,
    }),
    pay: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'braintree/pay',
        body
      }),
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetClientTokenQuery,
  usePayMutation,
} = braintreeApi;